import { capitalize } from "common/utils/strings";
import { classes } from "common/theme/theme";
import { State } from "protos/rtc/jobs";
import { stateToLocaleString } from "common/utils/enumTranslations";
import { useTranslation } from "react-i18next";
import React from "react";

export const JobStateChip: React.FC<{ state: State }> = ({ state }) => {
  const { t } = useTranslation();

  return (
    <span
      className={classes("bg-gray-500 text-white px-4 py-1 rounded-full", {
        "bg-success-700":
          state === State.IN_PROGRESS || state === State.COMPLETED,
        "bg-warning-500 text-gray-800": state === State.PAUSED,
        "bg-red-700": state === State.FAILED,
      })}
    >
      {capitalize(stateToLocaleString(t, state))}
    </span>
  );
};
